import React from 'react';
import ReactDOM from 'react-dom/client';
import "react-multi-carousel/lib/styles.css";
import './index.css';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// if (process.env.REACT_APP_ENVIRONMENT !== "test")
//     console.log = () => {};
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
